import { createSelector } from 'reselect';

import { AppState } from './models/app-state';

const state = (state: AppState): AppState => state;

export const defaultSearchParamsSelector = createSelector(
    state,
    () =>
        new URLSearchParams({
            limit: '50',
            page: '1',
        })
);
